import React, { useEffect } from 'react';
import './new.css';
import { Link } from 'react-router-dom';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';

export const Representation = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NavBar />
      <div className="tax-page">
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">IRS Tax Representation</h1>
            <Link to="/services" className="tax-notification-body">
              ← Back to Services
            </Link>
          </div>
        </div>

        <div className="tax-content-container">
          <h1 className="tax-section-title">
            Protect Your Rights with Expert IRS Representation
          </h1>
          <p className="tax-section-description">
            Facing the IRS can be stressful—but you don’t have to go through it
            alone. At Litax , we provide <strong>free, unlimited tax
            representation</strong> with the IRS, giving you peace of mind and
            professional advocacy at every stage. Our Certified Public
            Accountants (CPAs) and Enrolled Agents (EAs) stand by your side to
            ensure the best possible outcomes.
          </p>

          <h2 className="tax-subheading">What Is IRS Representation?</h2>
          <p className="tax-section-description">
            IRS representation means having qualified professionals handle your
            tax matters—whether it’s an audit, collection, or dispute. With us,
            you never have to face the IRS alone. We provide:
          </p>
          <ul className="tax-section-description">
            <li>
              <strong>Clear Communication:</strong> We act as your direct line
              with the IRS, ensuring your case is presented accurately and
              professionally.
            </li>
            <li>
              <strong>Thorough Documentation:</strong> Our experts prepare and
              organize all required documents to support your case.
            </li>
            <li>
              <strong>Negotiation Expertise:</strong> From payment plans to
              offers in compromise, we fight for the most favorable resolution.
            </li>
          </ul>

          <h2 className="tax-subheading">Why Work with CPAs and EAs?</h2>
          <ul className="tax-section-description">
            <li>
              <strong>Tax Law Expertise:</strong> Extensive knowledge of IRS
              codes and procedures ensures your rights are protected.
            </li>
            <li>
              <strong>Trusted Credentials:</strong> CPAs are state-licensed with
              strict ethical standards, while EAs are federally licensed to
              represent you nationwide.
            </li>
            <li>
              <strong>Year-Round Support:</strong> IRS issues can arise anytime,
              and we’re here whenever you need us.
            </li>
          </ul>

          <h2 className="tax-subheading">
            Why Choose Our Free Unlimited Tax Representation?
          </h2>
          <ul className="tax-section-description">
            <li>
              <strong>Peace of Mind:</strong> Experienced professionals manage
              the entire process for you.
            </li>
            <li>
              <strong>Zero Extra Cost:</strong> Get high-quality support without
              paying additional fees.
            </li>
            <li>
              <strong>Proactive Protection:</strong> We help prevent small
              issues from escalating into major problems.
            </li>
          </ul>

          <h2 className="tax-subheading">Get the Support You Deserve</h2>
          <p className="tax-section-description">
            At Litax , we believe every taxpayer deserves fair and
            professional representation. With our CPAs and EAs on your side,
            you’ll never have to face the IRS alone. <br />
            <strong>
              Contact us today to learn more about our free, unlimited IRS
              representation services and get the protection you need.
            </strong>
          </p>
        </div>
      </div>
      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default Representation;
